import { useHomeTranslation } from '../../../../hooks/translation/useHomeTranslation'
import { TrxSummary } from '../../../../models/transaction'
import { formatPrice } from '../../../../helpers/number-format'
import { CoreInfoCard } from 'components/cards'

interface props {
  loading: boolean
  trxProfileSummary?: TrxSummary
  shouldHideRevenueBreakdown?: boolean
  revenueShareRate?: number
}

const V3RevenueMetrics: React.FC<props> = ({
  loading,
  trxProfileSummary,
  shouldHideRevenueBreakdown = false,
  revenueShareRate
}) => {
  const { fromCharging, fromLoitering, fromGuestFee, fromFlatFee } = useHomeTranslation()
  const labelFormat = {
    label: (value: string | number) => <b>{value}</b>,
    subLabel: (value: string | number) => <span className="default-label">{value}</span>,
  }

  // Calculate revenue based on revenue share rate and kWh data
  const calculateTotalRevenue = () => {
    if (!trxProfileSummary) return 0

    // If revenue share is enabled, calculate revenue from (kWh / 1000) * rate and round to 2 decimals
    if (revenueShareRate && revenueShareRate > 0 && shouldHideRevenueBreakdown) {
      const kwhEnergy = trxProfileSummary.energyConsumeTotal || 0
      const revenue = (kwhEnergy / 1000) * revenueShareRate
      return Math.round(revenue * 100) / 100
    }

    // Otherwise use the regular revenue total (in cents, convert to dollars)
    return trxProfileSummary.revenueTotal ? trxProfileSummary.revenueTotal / 100.0 : 0
  }

  const totalRevenue = calculateTotalRevenue()

  const infoDetails = shouldHideRevenueBreakdown ? [] : [
    {
      label:
        trxProfileSummary && trxProfileSummary.revenueCharging
          ? formatPrice(trxProfileSummary.revenueCharging / 100.0)
          : formatPrice(0),
      subLabel: fromCharging,
      labelFormat,
    },
    {
      label:
        trxProfileSummary && trxProfileSummary.revenueLoitering
          ? formatPrice(trxProfileSummary.revenueLoitering / 100.0)
          : formatPrice(0),
      subLabel: fromLoitering,
      labelFormat,
    },
    {
      label:
        trxProfileSummary && (trxProfileSummary.revenueGuestFee !== undefined && trxProfileSummary.revenueGuestFee !== null)
          ? formatPrice(trxProfileSummary.revenueGuestFee / 100.0)
          : formatPrice(0),
      subLabel: fromGuestFee,
      labelFormat,
    },
    {
      label:
        trxProfileSummary && (trxProfileSummary.revenueFlatFee !== undefined && trxProfileSummary.revenueFlatFee !== null)
          ? formatPrice(trxProfileSummary.revenueFlatFee / 100.0)
          : formatPrice(0),
      subLabel: fromFlatFee,
      labelFormat,
    },
  ]
  return (
    <CoreInfoCard
      title="Revenue"
      wsLoading={loading}
      infoText={formatPrice(totalRevenue)}
      infoDetails={infoDetails}
    />
  )
}

export default V3RevenueMetrics
